module.exports = __webpack_public_path__ + "static/Faces-of-Philanthropy-4d74c557e2da26923ed00e8f411d72fc.jpg";